const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-red-500">403</h1>
        <p className="text-gray-600 mt-2">You are not authorized to view this page.</p>
        <a href="/dashboard" className="text-blue-600 hover:underline mt-4 block">
          Go to Dashboard
        </a>
      </div>
    </div>
  );
};

export default Unauthorized;